import Navbar from '../components/Navbar';
import '../styles/Contact.css';
import { MdCall, MdLocationCity, MdMail } from 'react-icons/md';
import Footer from '../components/Footer';
import Swal from 'sweetalert2';
import { SkipButton } from '../components/SkipButton';
import Resume from '../asset/Dokumentasi.pdf';

const Contact = () => {
  const handleLinkClick = (e) => {
    e.preventDefault();

    Swal.fire({
      title: 'Konfirmasi',
      text: 'Apakah Anda yakin ingin meninggalkan halaman ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ya',
      cancelButtonText: 'Tidak',
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.href = e.target.href;
      }
    });
  };
  return (
    <>
      <SkipButton idName='#contact-content' />
      <Navbar />
      <div className='contact-page'>
        <div className='contact-header__wrapper'>
          <h1 className='contact-title' id='contact-content'>
            BANTUAN
          </h1>
          <p className='contact-desc contact-header__desc'>
            <span>
              Anda memiliki kendala? Silahkan download{' '}
              <a href={Resume} download>
                disini
              </a>{' '}
            </span>
            <br /> Kendala belum terselesaikan? atau memiliki saran dan masukan
            terkait dengan aplikasi Qurtal? silahkan hubungi melalui ....
          </p>
        </div>
        <div className='contact-body__wrapper'>
          <div className='contact'>
            <MdMail className='contact-icon' />
            <p className='contact-desc'>EMAIL</p>
            <a
              href='mailto:aldo.wijaya2012@students.unila.ac.id'
              className='contact-link'
              onClick={handleLinkClick}
            >
              aldo.wijaya2012@students.unila.ac.id <br /> Student's email
            </a>
          </div>
          <div className='contact'>
            <MdCall className='contact-icon' />
            <p className='contact-desc'>WHATSAPP</p>
            <a
              href='https://wa.me/+6282180228516'
              className='contact-link'
              onClick={handleLinkClick}
            >
              +62 821 8022 8516 <br /> (Aldo)
            </a>
          </div>
          <div className='contact'>
            <MdLocationCity className='contact-icon' />
            <p className='contact-desc'>LOKASI</p>
            <a
              href='https://maps.app.goo.gl/nozfZo5vSt3QZRjv9'
              className='contact-link'
              onClick={handleLinkClick}
            >
              Laboratorium Komputer, <br /> Universitas Lampung
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
